import { defineType } from 'sanity';

export const aboutPage = defineType({
    name: 'aboutPage',
    title: 'About Page',
    type: 'document',
    fields: [
        {
            name: 'domainName',
            title: 'Domain Name',
            type: 'string',
        },
        {
            name: 'aboutPageComponents',
            title: 'About Page Components',
            type: 'factory',
        },
        {
            name: 'seo',
            title: 'SEO Settings',
            type: 'seo',
            description: 'Search engine optimization settings for better visibility',
        },
    ],
    preview: {
        select: {
            title: 'domainName',
        },
    },
});
